import { RadioGroup as RadioGroupPrimitive } from 'radix-ui';
import * as React from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';

export function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn('revers-radio-group', 'grid w-full gap-3', className)}
      {...props}
    />
  );
}

export function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        'revers-radio-group-item',
        'group/radio-group-item peer relative flex aspect-square size-4 shrink-0 cursor-pointer rounded-full border border-border-base-default outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring-base-default focus-visible:ring-3 focus-visible:ring-ring-base-default/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-border-danger-default aria-invalid:ring-3 aria-invalid:ring-border-danger-default/20 aria-invalid:aria-checked:border-border-primary-default data-checked:border-border-primary-default data-checked:bg-surface-primary-default data-checked:stext-inverse-default',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="revers-radio-group-indicator flex size-4 items-center justify-center"
      >
        <span className="absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-text-inverse-default" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}
